import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';
import './SuccessPage.css'; // We can reuse the same style as your success page

function UnsubscribedPage() {
  return (
    <>
      <Nav />
      <div className="success-container">
        <div className="success-box">
          <h2>You're Unsubscribed</h2>
          <p>You have been successfully removed from our newsletter.</p>
          <p>We are sad to see you leaving.</p>
          <p>Hope to see you again soon.</p>
          <Link to="/" className="success-home-button">
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UnsubscribedPage;
